import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const FungalInfectionPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Fungal Infections</h1>
        <section className="mb-8">
          <p>Fungal infections can affect various parts of the body, including skin, nails, and mucous membranes. They are caused by different types of fungi and can be persistent if not treated properly. Our natural therapies focus on eliminating the infection while strengthening the body's natural defenses.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Common Types</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Athlete's foot</li>
            <li>Ringworm</li>
            <li>Nail fungus</li>
            <li>Yeast infections</li>
            <li>Skin fungal infections</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Itching and burning</li>
            <li>Redness and inflammation</li>
            <li>Scaling or peeling skin</li>
            <li>Discolored nails</li>
            <li>Unpleasant odor</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use antifungal herbs, natural remedies, and lifestyle modifications to eliminate fungal infections and prevent recurrence. Each treatment plan is tailored to address your specific type of infection and overall health needs.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Natural antifungal properties</li>
            <li>Strengthens immune system</li>
            <li>No harsh side effects</li>
            <li>Prevents recurrence</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Keep affected areas clean and dry</li>
            <li>Wear breathable clothing</li>
            <li>Avoid sharing personal items</li>
            <li>Maintain good hygiene practices</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment cure fungal infections?</strong>
            <p>A: Yes, our natural remedies can effectively treat various types of fungal infections.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this safe for sensitive skin?</strong>
            <p>A: Yes, our treatments are gentle and suitable for all skin types.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I see improvement?</strong>
            <p>A: Many patients notice relief within a few weeks of starting treatment.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from fungal infections—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default FungalInfectionPage; 